import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import FinancialReport from "./FinancialReport";
import NewFinancialReport from "./NewFinancialReport";

const RoleBasedReportScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);

  if (!userInfo) return <div>Loading...</div>;

  const roleId = Number(userInfo.role);

  if (roleId==1) {
    return <FinancialReport />;
  } else {
    return <NewFinancialReport />; 
  }
};

export default RoleBasedReportScreen;
